import { STATE, MUTATIONS } from "./names";

export default {
    [MUTATIONS.SET_BUY_AUTOSHIP_DATA](state, payload) {
        state[STATE.BUY_AUTOSHIP_DATA] = payload;
    },
}
